// extracted by mini-css-extract-plugin
module.exports = {"input":"MaskedInput_input__3Larn","label":"MaskedInput_label__w2WMr","textContainer":"MaskedInput_textContainer__2TuCz"};